module.exports = __webpack_public_path__ + "img/14.495f5aab.jpg";